// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nc-select-users[data-v-e5d43b0e] .vs__selected {
	padding-inline: 0 5px !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcSelectUsers-CfOSPgtz.css"],"names":[],"mappings":";AACA;CACC,gCAAgC;AACjC","sourcesContent":["\n.nc-select-users[data-v-e5d43b0e] .vs__selected {\n\tpadding-inline: 0 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
